import React from "react";
import Avatar from "../../../../components/common/AvtarImage";

interface IFeedLogo {
  profileLogo: string;
  name: string;
  isCompany?:number;
}

const FeedLogo = ({ profileLogo, name ,isCompany}: IFeedLogo) => {

  return (
    <>
      <span className="feed-logo">
        <Avatar
          src={profileLogo}
          type={isCompany===2 ?"company":"candidate"}
        ></Avatar>
      </span>
    </>
  );
};
// <Image src={profileLogo} alt="profile logo" />

export default FeedLogo;
